export const STOCK_STATE = {
  OUT_OF_STOCK: 'OUT_OF_STOCK',
  IN_STOCK: 'IN_STOCK',
  LOW_IN_STOCK: 'LOW_IN_STOCK',
  IN_STOCK_SOON: 'IN_STOCK_SOON',
};
